/**
 * @description: sessionStorage keys used by the app for storing data
 * @property {string} nativePlatformType - The key for storing the native platform information - e.g. "android" or "ios"
 */
export const sessionStorageKeys = {
  nativePlatformType: 'nativePlatformType',
};
